<template>
  <v-toolbar dark :class="toolbarColor">
    <v-toolbar-title class="white--text hidden-sm-and-down">{{ title }}</v-toolbar-title>
    <v-toolbar-title class="white--text hidden-md-and-up">Nuevo</v-toolbar-title>
    <v-spacer></v-spacer>
    <div v-if="!readonly">
      <v-divider class="mx-4" inset vertical></v-divider>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="save"
            :name="buttons.save.name"
            :loading="loading"
            :disabled="disableSave"
            :color="colorButtonSave"
            dark
            fab
            small
            class="mx-2"
          >
            <v-icon color="white">{{ buttons.save.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ buttons.save.name }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="cancel"
            :name="buttons.cancel.name"
            :color="colorButtonCancel"
            dark
            fab
            small
            class="mx-2"
          >
            <v-icon color="white">{{ buttons.cancel.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ buttons.cancel.name }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    buttons: {
      save: {
        icon: 'mdi-content-save',
        name: 'Guardar',
      },
      cancel: {
        icon: 'mdi-close',
        name: 'Cancelar',
      },
    },
  }),
  props: {
    title: {
      type: String,
      required: true,
      default: 'Titulo',
    },
    loading: { default: false },
    disableSave: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    colorButtonSave: {
      type: String,
      required: false,
      default: 'green',
    },
    colorButtonCancel: {
      type: String,
      required: false,
      default: 'red',
    },
  },
  computed: {
    ...mapGetters({
      toolbarColor: 'theme/toolbarColor',
    }),
  },
  methods: {
    save(event) {
      this.$emit('save', event.target.name);
    },
    cancel(event) {
      this.$emit('cancel', event.target.name);
    },
  },
};
</script>
